export default "__VITE_ASSET__Fznuuy6Q__"